import React from 'react';
import { Switch } from 'react-router-dom';

import BareLayoutWithTracking from './containers/Layouts/BareLayoutWithTracking';
import DefaultLayout from './containers/Layouts/DefaultLayout';
import DefaultLayoutWithTracking from './containers/Layouts/DefaultLayoutWithTracking';

import {
  SWAPS,
  ACCOUNT_SWITCHER,
  RETURNS_HOME,
  RETURNS_LABEL,
  RETURNS_SELECT_DEVICE,
  RETURNS_SELECT_REASON,
  RETURNS_RETURN_METHODS,
  RETURNS_CONFIRMATION_ID,
  RETURNS_ORDER_STATUS,
  RETURNS_DOWNTIME,
  HOME,
} from './helpers/routes';

import Swaps from './containers/Swaps';
import AccountSwitcher from './containers/AccountSwitcher';
import Home from './containers/ReturnsHome';
import Returns from './containers/Returns';
import ReturnsDetail from './containers/Returns/ReturnsDetail';
import PrintLabel from './containers/Returns/PrintLabel';
import SelectDevice from './containers/Order/SelectDevice';
import ReturnReason from './containers/Order/ReturnReason';
import ReturnMethod from './containers/Order/ReturnMethod';
import NoMatch from './containers/Errors/NoMatch';
import ReturnsDowntime from './containers/Returns/ReturnsDowntime';
import Devices from './containers/Devices';


const Routes = props => (
  <Switch>
    <DefaultLayoutWithTracking
      exact
      path={ACCOUNT_SWITCHER}
      component={AccountSwitcher}
      {...props}
    />
    <DefaultLayout path={SWAPS} component={Swaps} {...props} />

    <DefaultLayoutWithTracking exact path={RETURNS_HOME} component={Home} />
    <BareLayoutWithTracking exact path={RETURNS_LABEL} component={PrintLabel} />
    <DefaultLayoutWithTracking
      exact
      path={RETURNS_SELECT_DEVICE}
      component={SelectDevice}
      hideFooter
    />
    <DefaultLayoutWithTracking exact path={RETURNS_SELECT_REASON} component={ReturnReason} />
    <DefaultLayoutWithTracking exact path={RETURNS_RETURN_METHODS} component={ReturnMethod} />
    <DefaultLayout exact path={RETURNS_CONFIRMATION_ID} component={ReturnsDetail} />
    <DefaultLayoutWithTracking path={RETURNS_ORDER_STATUS} component={Returns} />
    <DefaultLayoutWithTracking path={RETURNS_DOWNTIME} component={ReturnsDowntime} />
    <DefaultLayoutWithTracking exact path={HOME} component={Devices} />
    <DefaultLayoutWithTracking component={NoMatch} {...props} />
  </Switch>
);

export default Routes;
